import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axiosInstance, { serverURL } from "../../services/FetchNodeServices";

const AllCatalog = () => {
    const [catalogues, setCatalogues] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const [page, setPage] = useState(1);
    const [limit] = useState(2);
    const [totalPages, setTotalPages] = useState(1);

    useEffect(() => {
        fetchCatalogues(page);
    }, [page]);

    // Fetch all catalogues with pagination
    const fetchCatalogues = async (pageNumber) => {
        setIsLoading(true);
        try {
            const res = await axiosInstance.get(
                `/api/v1/catalogues/get-all-catalogue-pdf-with-pagination?page=${pageNumber}&limit=${limit}`
            );

            if (res.status === 200) {
                setCatalogues(res?.data?.data || []);
                setTotalPages(res?.data?.totalPages || 1);
            }
        } catch (error) {
            toast.error("Error fetching catalogues");
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    // Delete Catalogue
    const handleDelete = async (id) => {
        const confirmDelete = await Swal.fire({
            title: "Are you sure?",
            text: "This action cannot be undone.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
        });

        if (confirmDelete.isConfirmed) {
            try {
                const res = await axiosInstance.delete(`/api/v1/catalogues/delete-catalogue/${id}`);

                if (res.status === 200) {
                    Swal.fire("Deleted!", "Catalogue has been deleted.", "success");

                    // Refresh current page
                    fetchCatalogues(page);
                }
            } catch (error) {
                Swal.fire("Error!", "Unable to delete catalogue.", "error");
                console.error(error);
            }
        }
    };

    const handleNext = () => {
        if (page < totalPages) setPage(page + 1);
    };

    const handlePrev = () => {
        if (page > 1) setPage(page - 1);
    };

    if (isLoading) return <p>Loading Catalogues...</p>;

    return (
        <>
            <ToastContainer />

            <div className="bread">
                <div className="head">
                    <h4>All Catalogues</h4>
                </div>

                <div className="links d-flex align-items-center gap-3">
                    <Link to="/add-catalogue" className="add-new">
                        Add New <i className="fa-solid fa-plus"></i>
                    </Link>
                </div>
            </div>

            <section className="main-table mt-3">
                <table className="table table-bordered table-striped table-hover">
                    <thead>
                        <tr>
                            <th>Sr.No.</th>
                            <th>Name</th>
                            <th>Catalogue PDF</th>
                            <th>Edit</th>
                            <th>Delete</th>
                        </tr>
                    </thead>

                    <tbody>
                        {catalogues.length > 0 ? (
                            catalogues.map((item, index) => (
                                <tr key={item._id}>
                                    <td>{(page - 1) * limit + index + 1}</td>

                                    <td>{item.name}</td>

                                    <td>
                                        <a
                                            href={`${serverURL}/${item.file}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="btn btn-primary btn-sm"
                                        >
                                            View PDF
                                        </a>
                                    </td>

                                    <td>
                                        <Link to={`/edit-catalogue/${item._id}`} className="bt edit">
                                            Edit <i className="fa-solid fa-pen-to-square"></i>
                                        </Link>
                                    </td>

                                    <td>
                                        <button
                                            className="bt delete cursor-pointer"
                                            onClick={() => handleDelete(item._id)}
                                        >
                                            Delete <i className="fa-solid fa-trash"></i>
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="5" className="text-center">
                                    No catalogues found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>

                {/* Pagination */}
                {totalPages > 1 &&
                    <div className="d-flex justify-content-center gap-3 mt-4">
                        <button
                            className="btn btn-secondary"
                            disabled={page === 1}
                            onClick={handlePrev}
                        >
                            Previous
                        </button>

                        <span className="align-self-center">
                            Page <strong>{page}</strong> of <strong>{totalPages}</strong>
                        </span>

                        <button
                            className="btn btn-secondary"
                            disabled={page === totalPages}
                            onClick={handleNext}
                        >
                            Next
                        </button>
                    </div>
                }

            </section>
        </>
    );
};

export default AllCatalog;
